export default __webpack_public_path__ + "static/media/logo.c1cc2d6d.svg";